import { createFileRoute } from "@tanstack/react-router";

type CskhSearch = { tab?: string | undefined };

export const Route = createFileRoute("/_app/cskh/")({
  validateSearch: (search: Record<string, unknown>): CskhSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
});
